import { DISPLAY_TYPES } from './FieldTypes';

export const CATEGORIES = {
  MAIN_SETTINGS: 'mainSettings',
  TEST_CONTENT: 'testContent',
  COMMANDS: 'commands',
  FUSES: 'fuses',
  STRAPS: 'straps',
};

export const MAIN_SETTINGS = {
  TIMEOUT: {
    fieldDescription: 'Timeout (cycles)',
    titlePosition: 'left',
    placeholder: 'cycles',
    width: '40%',
    actionObj: {
      category: 'mainSettings',
      fieldName: 'timeout',
    },
    fieldType: DISPLAY_TYPES.TEXT,
  },
  SEED: {
    fieldDescription: 'Seed',
    titlePosition: 'left',
    placeholder: 'Seed',
    width: '40%',
    actionObj: {
      category: 'mainSettings',
      fieldName: 'seed',
    },
    fieldType: DISPLAY_TYPES.TEXT,
  },
  INTERACTIVE: {
    fieldDescription: 'Interactive Run',
    titlePosition: 'left',
    actionObj: {
      category: 'mainSettings',
      fieldName: 'interactive',
    },
    warningText: 'Turning Interactive run might result in a slower runtime.',
    dialogMessage:
      'Are you sure you want to turn on Interactive run? this might result in slower runtime.',
    fieldType: DISPLAY_TYPES.CHECKBOX,
  },
  HSLE: {
    fieldDescription: 'HSLE',
    titlePosition: 'left',
    actionObj: {
      category: 'mainSettings',
      fieldName: 'hsle',
    },
    fieldType: DISPLAY_TYPES.CHECKBOX,
  },
};

export const TEST_CONTENT_TYPE_SELECT = {
  TEST_OBJECT: {
    fieldDescription: 'Test Object',
    titlePosition: 'left',
    width: '40%',
    actionObj: {
      category: 'testContent',
      fieldName: 'testObject',
    },
    data: [
      {
        value: 'obj',
        label: 'Obj File',
      },
      {
        value: 'perspec',
        label: 'Perspec',
      },
    ],
    fieldType: DISPLAY_TYPES.DROPDOWN,
  },
};

export const TEST_CONTENT_OBJ = {
  OBJ_PATH: {
    fieldDescription: 'Path to .obj file',
    titlePosition: 'left',
    placeholder: 'Path',
    actionObj: {
      category: 'testContent',
      fieldName: 'objPath',
    },
    fieldType: DISPLAY_TYPES.TEXT,
  },
  OBJ_NAME: {
    fieldDescription: '.obj file new name',
    titlePosition: 'left',
    placeholder: 'Name',
    actionObj: {
      category: 'testContent',
      fieldName: 'objName',
    },
    fieldType: DISPLAY_TYPES.TEXT,
  },
};

export const TEST_CONTENT_PERSPEC = {
  PLATFORM_CONFIG_PATH: {
    fieldDescription: 'Platform Config (.xml) Path',
    titlePosition: 'left',
    placeholder: 'Path',
    actionObj: {
      category: 'testContent',
      fieldName: 'platformConfigPath',
    },
    fieldType: DISPLAY_TYPES.TEXT,
  },
  ACTION_NAME: {
    fieldDescription: 'Action Name',
    titlePosition: 'left',
    placeholder: 'Action Name',
    actionObj: {
      category: 'testContent',
      fieldName: 'actionName',
    },
    fieldType: DISPLAY_TYPES.TEXT,
  },
  PSF_FILES: {
    fieldDescription: '.psf Files',
    titlePosition: 'left',
    placeholder: 'file1;\nfile2;\n...',
    actionObj: {
      category: 'testContent',
      fieldName: 'psfFiles',
    },
    fieldType: DISPLAY_TYPES.TEXT_BOX,
  },
  SLN_FILES: {
    fieldDescription: '.sln Files',
    titlePosition: 'left',
    placeholder: 'file1;\nfile2;\n...',
    actionObj: {
      category: 'testContent',
      fieldName: 'slnFiles',
    },
    fieldType: DISPLAY_TYPES.TEXT_BOX,
  },
};

export const COMMANDS = {
  PRE_COMMANDS: {
    fieldDescription: 'Pre Commands',
    titlePosition: 'left',
    placeholder: 'Pre Commands...',
    actionObj: {
      category: 'commands',
      fieldName: 'preCommands',
    },
    fieldType: DISPLAY_TYPES.TEXT_BOX,
  },
  POST_COMMANDS: {
    fieldDescription: 'Post Commands',
    titlePosition: 'left',
    placeholder: 'Post Commands...',
    actionObj: {
      category: 'commands',
      fieldName: 'postCommands',
    },
    fieldType: DISPLAY_TYPES.TEXT_BOX,
  },
};
